export default "__VITE_ASSET__eirsblT5__"